import { render, staticRenderFns } from "./UplimitPromotion.vue?vue&type=template&id=f60d3c3e&scoped=true"
import script from "./UplimitPromotion.vue?vue&type=script&lang=js"
export * from "./UplimitPromotion.vue?vue&type=script&lang=js"
import style0 from "./UplimitPromotion.vue?vue&type=style&index=0&id=f60d3c3e&prod&scoped=true&lang=css"
import style1 from "./UplimitPromotion.vue?vue&type=style&index=1&id=f60d3c3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60d3c3e",
  null
  
)

export default component.exports